// Persistence for the All Tasks filter bar.
//
// Filters survive navigating between views AND a page refresh, so you don't
// lose your place while working. They auto-clear at the first load on/after
// 9:00 AM local time each day, so yesterday's filter can't quietly hide work
// from you. There is also an explicit Reset button in the UI.

const STORAGE_KEY = 'lmr.taskFilters.v1'

export const DEFAULT_FILTERS = {
  search: '',
  filterClient: '',
  filterAssignee: '',
  filterStatuses: [],
  filterArea: '',
  filterOnboarding: false,
  filterCollaborator: '',
  filterAssigner: '',
  hideCompleted: false,
  showUrgentOnly: false,
  dueFilter: '',          // '' | 'overdue' | 'today' | 'week' | 'none'
  sortBy: 'due_asc',
  groupBy: 'client',
}

// The most recent 9:00 AM boundary. Saved state older than this is stale.
function lastResetBoundary(now = new Date()) {
  const boundary = new Date(now)
  boundary.setHours(9, 0, 0, 0)
  if (now < boundary) boundary.setDate(boundary.getDate() - 1)
  return boundary
}

export function loadFilters() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...DEFAULT_FILTERS }
    const saved = JSON.parse(raw)
    if (!saved || typeof saved !== 'object') return { ...DEFAULT_FILTERS }
    const savedAt = saved.savedAt ? new Date(saved.savedAt) : null
    if (!savedAt || isNaN(savedAt.getTime()) || savedAt < lastResetBoundary()) {
      window.localStorage.removeItem(STORAGE_KEY)
      return { ...DEFAULT_FILTERS }
    }
    // Merge onto defaults so newly added filter keys don't come back undefined.
    const merged = { ...DEFAULT_FILTERS }
    Object.keys(DEFAULT_FILTERS).forEach(k => {
      if (saved[k] !== undefined && saved[k] !== null) merged[k] = saved[k]
    })
    if (!Array.isArray(merged.filterStatuses)) merged.filterStatuses = []
    return merged
  } catch {
    return { ...DEFAULT_FILTERS }
  }
}

export function saveFilters(filters) {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...filters, savedAt: new Date().toISOString() })
    )
  } catch { /* storage unavailable — filters just won't persist */ }
}

export function clearSavedFilters() {
  try { window.localStorage.removeItem(STORAGE_KEY) } catch { /* noop */ }
}

// Which filters are currently doing something? Used to render the active-filter
// chips and the count on the Reset button.
export function activeFilterCount(f) {
  let n = 0
  if (f.search) n++
  if (f.filterClient) n++
  if (f.filterAssignee) n++
  if (f.filterStatuses.length) n++
  if (f.filterArea) n++
  if (f.filterOnboarding) n++
  if (f.filterCollaborator) n++
  if (f.filterAssigner) n++
  if (f.hideCompleted) n++
  if (f.showUrgentOnly) n++
  if (f.dueFilter) n++
  return n
}
